import React, {Component} from "react"
import {isString, omit} from "lodash"
import styled from "styled-components"

import {Select} from "@irati/ui/src/FormItem"
import id from "@irati/utils/id"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import RewardCatalogueRewardsQuery, {RewardCatalogueRewardData, variables} from "@irati/reward/apollo/query/RewardCatalogueRewards"
import {Reward} from "@irati/types"

import RewardRow from "./RewardRow"

/* eslint-disable max-len */
export const customRewardThumbnail = "https://res.cloudinary.com/perkbox/image/upload/v1552919889/eac9df93-c2a6-4f6d-8a50-654de1bd3a4e.png"
/* eslint-enable max-len */

const PROPERTY = "reward"

const StyledDiv = styled.div`
  display: grid;
`

interface Props extends InjectIntl {
  label: string
  onChange(reward?: Reward, custom?: string): void
  placeholder: string
  required: boolean
}

interface State {
  rewardSearchText: string
}

class Search extends Component<Props> {
  static defaultProps = {
    arrowRenderer: null,
    id: "rewardSearch",
    label: "recognition.fields.poll.reward.label",
    labelKey: "alt",
    optionRenderer: RewardRow,
    placeholder: "recognition.fields.poll.reward.placeholder",
    required: false,
    valueKey: "alt",
    valueRenderer: RewardRow
  }

  state: State = {
    rewardSearchText: ""
  }

  buildOptions = (rewards: Reward[]) => {
    return rewards.map((reward: Reward) => {
      return {...reward, desc: reward.header, alt: reward.header, img: reward.thumbnailImage}
    })
  }

  handleChange = (value, option) => {
    const {onChange} = this.props
    const reward = option.uuid ? omit(option, ["desc", "alt", "img"]) : null
    const custom = !option.uuid ? option.alt : null
    return onChange(reward, custom)
  }

  handleRewardList = (rewardSearchText: string) => {
    this.setState({rewardSearchText})
  }

  getLabel = () => {
    const {required} = this.props
    return required ? "recognition.rewards.picker.search.label.required" : "recognition.rewards.picker.search.label.optional"
  }

  render() {
    const {intl, ...props} = this.props

    return (
      <RewardCatalogueRewardsQuery variables={{rewardsForMyPackage: true, ...variables, q: this.state.rewardSearchText}} useLoader={false}>
        {({data, loading: isLoading}: RewardCatalogueRewardData) => {
          if (!data || !data.rewardCatalogueRewards) {
            return []
          }
          return (
            <StyledDiv>
              <Select
                {...props}
                isCreatable
                id={id(PROPERTY, this.props)}
                isValidNewOption={(option) => isString(option.label) && option.label.trim() !== ""}
                label={intl.formatMessage({id: this.getLabel()})}
                name={id(PROPERTY, this.props)}
                onChange={this.handleChange}
                onInputChange={this.handleRewardList}
                options={this.buildOptions(data.rewardCatalogueRewards.results)}
                promptTextCreator={(reward) => intl.formatMessage({id: "recognition.fields.poll.reward.promptText"}, {reward})}
                isLoading={isLoading}
              />
            </StyledDiv>
          )
        }}
      </RewardCatalogueRewardsQuery>
    )
  }
}

export default injectIntl(Search)
